import React from "react";
import Done from "@material-ui/icons/Check";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CloudDownload from "@material-ui/icons/CloudDownload";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { CSVLink } from "react-csv";
import { restClient } from "ra-data-feathers";
import { GET_LIST, Loading } from "react-admin";
import feathersClient from "../feathersClient";

const dataProvider = restClient(feathersClient, { id: "_id", usePatch: true });

export const styles = {
  title: {
    fontSize: 25,
    paddingBottom: 10
  },
  card: {
  },
  fetchButton: {
    backgroundColor: "#7CB342",
    color: "#fff",
    fontWeight: "bold",
    minWidth: "100%"
  },
  doneButton: {
    backgroundColor: "#2196f3",
    color: "#fff",
    fontWeight: "bold"
  },
  displayHide: {
    display: 'none'
  }
};


export class DownloadButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataToExport: [],
      dowloadCsv: false,
      notInfoToCsv: false,
      loading: false,
      mensaje: 'Descargar CSV'
    };
  }
  onClickLoadPesajes = e => {
    this.setState({loading: true, mensaje: "procesando..." });
    dataProvider(GET_LIST, "recuperadores", {filter: { $limit: "false"}  }).then(response => {
      if (response.data[0]) {
        const csvData = [];
        csvData.push(["ID", "Nombre/Apellido", "Etapa", "Descripción", "Bolsón", "F. Nacimiento"]);
        response.data.forEach(row => {
          csvData.push([
            row.legacyId,
            row.nombre,
            row.etapa,
            row.descripcion,
            row.bolson,
            row.fecha_nac
          ])
          }
        );
        this.setState({
          dataToExport: csvData
        });
        const buttonPeso = document.getElementsByClassName("csvDowload");
        const listButton = Array.from(buttonPeso);
        listButton[0].click();
        this.setState({loading: false });
        this.setState({ dowloadCsv: true });
      } else {
        this.setState({ notInfoToCsv: true });
      }
    }).catch((err) => {
      this.setState({loading: false });
      this.setState({ notInfoToCsv: true });
    });
  };

  render() {
    const { dowloadCsv, notInfoToCsv, loading, mensaje } = this.state;
    return !dowloadCsv && !notInfoToCsv ? (
      <div>
        <Button
          variant="contained"
          color="primary"
          style={this.props.fetchButtonStyles}
          onClick={this.onClickLoadPesajes}
        >
          { mensaje }
        </Button>
        <CSVLink
          className="csvDowload"
          filename="recuperadores.csv"
          data={this.state.dataToExport}
          style={{ textDecoration: "none", color: "#fff", display: "none" }}
        />
        <p></p>
        { loading && <Loading loadingPrimary="Creando CSV" loadingSecondary="espere hasta que termine..."/>}
      </div>
    ) : !dowloadCsv && notInfoToCsv ? (
      <Button
        disabled={true}
        style={{
          boxShadow:
            "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
          backgroundColor: "#d5d5d5",
          color: "rgb(255, 255, 255)",
          fontWeight: "bold",
          lineHeight: "30px",
          minWidth: "260px"
        }}
      >
        No hay datos Disponibles
      </Button>
    ) : (
      <Button
        variant="contained"
        color="primary"
        style={this.props.fetchButtonStyles}
        onClick={() => {
          this.setState({ dowloadCsv: true });
        }}
      >
        {this.state.dowloadCsv ? (
          <Done style={{ fontSize: 25, marginRight: 10 }} />
        ) : (
          <CloudDownload style={{ fontSize: 25, marginRight: 10 }} />
        )}
      </Button>
    );
  }
}

export class ExportarCartonerosCsv extends React.Component {
  constructor(props) {
    super(props);
    this.styles = props.styles;
    this.state = {
      monthId: 0
    };
  }

  renderCartonerosList() {
    return (
      <div>
        <Typography style={styles.title}>
          Descarga los recuperadores
        </Typography>
        <Card style={styles.card}>
          <CardContent>
                  <DownloadButton
                    handleDownloadClick={this.handleDownloadClick}
                    doneButtonStyles={styles.doneButton}
                    fetchButtonStyles={styles.fetchButton}
                  />

          </CardContent>
        </Card>
      </div>
    );
  }

  render() {
    return this.renderCartonerosList();
  }
}



// WEBPACK FOOTER //
// ./src/components/ExportarCartonerosCsv.js